import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from '../locales/en/all.js';
import translationES from '../locales/es/all.js';
import translationHT from '../locales/ht/all.js';

const resources = {
    en: {
      translation: translationEN
    },
    es: {
      translation: translationES
    },
    ht: {
      translation: translationHT
    }
  };

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: ['querystring','path','querystring'],
    },
  });

export default i18n;